import React from 'react';
import styled from 'styled-components';
import { NewBackButton } from '../svgs';

const BackButton = ({ onClick = () => { }, ...rest }) => {
    return (
        <BackButtonContainer
            {...rest}
            onClick={onClick}
        >
            <NewBackButton />
        </BackButtonContainer>

    )
}

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  margin: 8px;
  top: 10px;
  left: 10px;
  z-index: 2;
  position:fixed;
`;

export default BackButton;